// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--3VpLX";
export const title = "footer-module--title--3v0SS";
export const map = "footer-module--map--2mlIG";
export const logo = "footer-module--logo--1khNe";
export const links = "footer-module--links--1gzAj";